import { BaseComponent, BElement } from "utils/base-component"
import "./index.scss"
import "./static/icon-close.svg"
import "./static/smartbar-icon.svg"

export class Smartbar extends BaseComponent {
  static cssClass = "smartbar"

  private close!: BElement
  private closedClass!: string

  init() {
    const closeElement = this.element("close-button")
    if (!closeElement) {
      throw new Error("Close button not found")
    }
    this.close = closeElement

    this.closedClass = `${Smartbar.cssClass}--closed`

    if (document.cookie.indexOf("smartbarClosed=1") !== -1) {
      this.root.classList.add(this.closedClass)
      document.documentElement.style.paddingTop = "0"
      document.documentElement.style.setProperty("--smartbar-offset", "0px")
    } else {
      document.documentElement.style.setProperty("--smartbar-offset", "84px")
    }

    this.close.element.addEventListener("click", (e) => {
      e.preventDefault()

      const expiryDate = new Date()
      expiryDate.setMonth(expiryDate.getMonth() + 1)

      document.cookie = `smartbarClosed=1; expires=${expiryDate.toUTCString()}; path=/`

      this.root.classList.add(this.closedClass)
      document.documentElement.style.paddingTop = "0"
      document.documentElement.style.setProperty("--smartbar-offset", "0px")
    })
  }
}
